import PrivacyPolicy from './privacyPolicy';
import TelehealthConsent from './telehealthConsent';
import TermsOfService from './termsOfService';

const LegalLinks = { PrivacyPolicy, TermsOfService, TelehealthConsent };

export default LegalLinks;
